import React, { useMemo } from "react";
import { BaseModal } from "../../../atoms/base-modal";
import {
  OrgProductType,
  PlanTypeLiterals,
  ProductPlanMap,
  PlanNameMap,
  isOrgProduct,
} from "../../../../application/domain/organization/org-product";
import { toast } from "react-toastify";
import {
  formatErrorMessage,
  validateTermsOfUseURL,
} from "../../../../application/domain/terms-of-use/terms-of-use";

interface OrgProductUpdateModalProps {
  orgProduct: OrgProductType;
  isActive: boolean;
  onSubmit: (orgProduct: OrgProductType) => void;
  onCancel: () => void;
}

export const OrgProductUpdateModal: React.FC<OrgProductUpdateModalProps> = ({
  orgProduct,
  isActive,
  onSubmit,
  onCancel,
}) => {
  const [editOrgProduct, setEditOrgProduct] =
    React.useState<OrgProductType>(orgProduct);

  const isValid = useMemo(() => {
    return validateTermsOfUseURL(
      orgProduct.productCode,
      editOrgProduct.legalTermUrl,
    );
  }, [orgProduct, editOrgProduct]);

  return (
    <BaseModal
      isActive={isActive}
      title={"製品プランの変更"}
      onClose={onCancel}
    >
      <section className="modal-card-body">
        <div className="field">製品プラン、利用規約URLを変更してください。</div>
        <div className="field">
          <label className="label">製品プラン</label>
          <div className="control">
            <div className="select">
              <select
                value={editOrgProduct.plan}
                onChange={(e) => {
                  if (e.target.value.length > 0) {
                    setEditOrgProduct({
                      ...editOrgProduct,
                      plan: e.target.value as PlanTypeLiterals,
                    });
                  }
                }}
              >
                {ProductPlanMap[orgProduct.productCode].map((v) => (
                  <option key={v} value={v}>
                    {PlanNameMap[v]}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="field">
          <label className="label">利用規約URL</label>
          <input
            value={editOrgProduct.legalTermUrl}
            name="legalTermUrl"
            placeholder="利用規約URL"
            className={"input"}
            onChange={(e) => {
              setEditOrgProduct({
                ...editOrgProduct,
                legalTermUrl: e.target.value,
              });
            }}
          />
          {!isValid && (
            <div className="help is-danger">{formatErrorMessage}</div>
          )}
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={onCancel}>
          キャンセル
        </button>
        <button
          className={"button is-info is-fullwidth"}
          onClick={async () => {
            if (isOrgProduct(editOrgProduct)) {
              onSubmit(editOrgProduct);
            } else {
              toast.error("入力内容を確認してください。");
            }
          }}
          disabled={!isValid}
        >
          変更
        </button>
      </footer>
    </BaseModal>
  );
};
